export default "__VITE_ASSET__cQ6$azym__"